var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #bcbccb;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icon_search",
    className: "cls-1",
    d: "M15.875,14.037a8.471,8.471,0,0,0,1.75-5.217A8.775,8.775,0,0,0,8.875,0,8.882,8.882,0,0,0,0,8.82a8.882,8.882,0,0,0,8.875,8.82,8.333,8.333,0,0,0,5.25-1.739l3.75,3.727a1.214,1.214,0,0,0,1.75,0,1.2,1.2,0,0,0,0-1.739Zm-7,.994A6.277,6.277,0,0,1,2.5,8.82a6.375,6.375,0,0,1,12.75,0A6.277,6.277,0,0,1,8.875,15.031Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/Search.b4843426461e065a607b82de7b86a8ea.svg";
export { ForwardRef as ReactComponent };